export default __webpack_public_path__ + "static/media/rotatingsphere.b7245162.gif";